// extracted by mini-css-extract-plugin
module.exports = {"root":"SubSuccessModal_root__83KE5","browseAction":"SubSuccessModal_browseAction__31qvv","icon":"SubSuccessModal_icon__27N1t","text":"SubSuccessModal_text__3QjDs"};